import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface UpdateDiagnosisByIdPayload {
  name: string
}

export async function updateDiagnosisById(
  demandId: string,
  payload: UpdateDiagnosisByIdPayload,
) {
  return companiesApi.patch(apiRoutes.updateDiagnosisById(demandId), payload)
}
